import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import { CustomTheme } from "../../types/customTheme";
import { makeStyles, useTheme } from "@material-ui/core";

export interface DialogCommonDefaultProps {
  open: boolean;
  setOpen: any;
  children: any;
  isNeedFixedHeight: any;
  backgroundColor?: any;
  maxWidth?: any;
  style?: any;
  paperStyle?: any; // Add this for paper-specific styles
}

/* Common modal UI.. */
const DialogCommonDefault: React.FunctionComponent<
  DialogCommonDefaultProps
> = ({
  open,
  setOpen,
  children,
  isNeedFixedHeight,
  backgroundColor,
  maxWidth,
  style,
  paperStyle,
}) => {
  const theme: CustomTheme = useTheme();
  
  // Merge the paper style with the existing styles
  const getPaperStyle = () => {
    const baseStyle = isNeedFixedHeight
      ? {
          borderRadius: 10,
          border: `1px solid ${theme.palette.background.entity_border}`,
          backgroundColor: backgroundColor
            ? backgroundColor
            : theme.palette.background.backgroundColor,
          width: "100%",
          height: "100%",
        }
      : {
          borderRadius: 10,
          border: `1px solid ${theme.palette.background.entity_border}`,
          backgroundColor: backgroundColor
            ? backgroundColor
            : theme.palette.background.backgroundColor,
          width: "100%",
        };
    
    // Merge with paperStyle if provided
    return paperStyle ? { ...baseStyle, ...paperStyle } : baseStyle;
  };

  return (
    <Dialog
      PaperProps={{
        style: getPaperStyle(),
      }}
      style={{ width: "100%", ...style }}
      maxWidth={maxWidth}
      fullWidth
      open={open}
      onClose={() => setOpen(false)}
      disableBackdropClick
      disableEscapeKeyDown
      scroll="body" 
    >
      {children}
    </Dialog>
  );
};

export default DialogCommonDefault;